import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials() {
  return (
    <section id="stories" className="py-24 sm:py-32 bg-ivory" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Client Stories"
          title="Real People. Real Journeys. Real Changes."
          sub="Stories from coaching journeys with Dr. Anjali."
        />
        <div className="flex gap-6 overflow-x-auto pb-6 snap-x snap-mandatory no-scrollbar lg:grid lg:grid-cols-3 lg:overflow-visible lg:pb-0">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 0.06} className="min-w-[85%] sm:min-w-[55%] lg:min-w-0 snap-center">
              <motion.figure
                whileHover={{ y: -8 }}
                transition={{ duration: 0.35 }}
                className="h-full bg-cardbg border border-botanical/10 rounded-3xl p-8 shadow-card hover:shadow-hover transition-shadow duration-300 flex flex-col"
                data-testid={`testimonial-card-${i}`}
              >
                <div className="mb-5">
                  <Quote size={26} className="text-gold" />
                </div>
                <blockquote className="font-serif italic text-lg leading-relaxed text-inkbody flex-1">
                  "{t.quote}"
                </blockquote>
                <p className="mt-5 text-sm font-semibold text-sage leading-snug">{t.result}</p>
                <figcaption className="mt-6 pt-5 border-t border-botanical/10 flex items-center gap-3.5">
                  <div className="w-11 h-11 rounded-full bg-forest flex items-center justify-center shrink-0">
                    <span className="font-serif text-lg text-gold">{t.name[0]}</span>
                  </div>
                  <div>
                    <p className="text-sm font-bold text-forest">
                      {t.name}, {t.age}
                    </p>
                    <p className="text-xs text-inkmuted">
                      {t.role} • {t.concern}
                    </p>
                  </div>
                </figcaption>
              </motion.figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
